<div class="shift-legend flex-row">
    <div class="grow-4"></div>
    <div *ngFor="let shift of shifts" class="shift flex-row">
        <ng-container *ngIf="shift[0].shiftName">
            <div class="box-color" [ngStyle]="styleShiftLegend(shift[0])"></div>
            <div class="shift-name">
                {{ "shift_" | lang }} {{ shift[0].shiftName }}
            </div>
        </ng-container>
    </div>
    <div class="shift-name flex-row">
        {{ "total-loops" | lang }}: {{ totalLoops }}
    </div>

    <div class="grow-4"></div>
</div>

<div #chartTarget *ngIf="requestState"></div>
